import { apiGet, apiPatch, apiPost, apiPut } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { LoginRequest, LoginResponse, ProfileResponse, RegisterRequest, RegisterResponse } from '@/constants/types';
// import toast from 'react-hot-toast';

class AuthService {
  async login(loginData: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await apiPost<LoginResponse>(
        API_ENDPOINTS.AUTH.LOGIN,
        loginData,
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  async register(registerData: RegisterRequest): Promise<RegisterResponse> {
    try {
      // Remove confirmPassword from the request body as the API doesn't need it
      const { confirmPassword, ...requestData } = registerData;
      
      const response = await apiPost<RegisterResponse>(
        API_ENDPOINTS.AUTH.REGISTER,
        requestData,
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      console.log(error.response?.data.errors?.length >0 ?error.response?.data.errors[0].message :'Registration failed')
        //  toast.error(error.response?.data.errors?.length >0 ?error.response?.data.errors[0].message :'Registration failed')
      throw new Error(error.response?.data.errors?.length >0 ?error.response?.data.errors[0].message :'Registration failed')
    }
  }

  async getProfile(): Promise<ProfileResponse> {
    try {
      const response = await apiGet<ProfileResponse>(
        API_ENDPOINTS.AUTH.PROFILE,
        { showLoader: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch profile');
    }
  }

  async logout(): Promise<void> {
    try {
      await apiPost(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error: any) {
      console.error('Logout error:', error);
    }
  }
// curl -X 'PATCH' \
//   'http://localhost:5000/api/auth/resume' \
//   -H 'accept: application/json' \
//   -H 'Content-Type: application/json' \
//   -d '{
//   "jobPreferences": {
//     "resumeId": "507f1f77bcf86cd799439011"
//   }
// }'
  async updateProfile(profileData: Partial<ProfileResponse|any>): Promise<ProfileResponse> {
    try {
      const response = await apiPut<ProfileResponse>(
        API_ENDPOINTS.AUTH.PROFILE,
        profileData,
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw error.response?.data || { message: 'Profile update failed' };
    }
  }

    async removeUserProfile(profileData: Partial<any>): Promise<ProfileResponse> {
    try {
      const response = await apiPatch<ProfileResponse>(
        API_ENDPOINTS.AUTH.RESUME,
        profileData,
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Update failed');
    }
  }
  async updateProfilePicture(profilePictureId: string): Promise<any> {
    try {
      const response = await apiPatch<any>(
        API_ENDPOINTS.AUTH.PROFILE_PICTURE,
        {profilePictureId:profilePictureId},
        { showLoader: false, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Profile update failed');
    }
  }
  async verifyEmail(token: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiGet<{ success: boolean; message: string }>(
        `${API_ENDPOINTS.AUTH.VERIFY_EMAIL}?token=${token}`,
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Email verification failed');
    }
  }

  async resetPassword(token: string, password: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiPost<{ success: boolean; message: string }>(
        API_ENDPOINTS.AUTH.RESET_PASSWORD,
        { token, password },
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Password reset failed');
    }
  }

  async forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiPost<{ success: boolean; message: string }>(
        API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
        { email },
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to send password reset email');
    }
  }

  async resendVerification(email: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiPost<{ success: boolean; message: string }>(
        API_ENDPOINTS.AUTH.RESEND_VERIFICATION,
        { email },
        { showLoader: true, backdrop: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to resend verification email');
    }
  }

  async refreshToken(): Promise<LoginResponse> {
    try {
      const response = await apiPost<LoginResponse>(
        API_ENDPOINTS.AUTH.REFRESH_TOKEN,
        {},
        { showLoader: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Token refresh failed');
    }
  }
}

export const authService = new AuthService();